module.exports = __webpack_public_path__ + "static/media/image006.d672fd3a.jpg";